import { StoreState } from '../store-interfaces';

export const hasFBOauthTokensSelector = (state: StoreState) =>
  state.fbOauthTokens.entities.length > 0;

export const fbOauthTokensLoadedSelector = (state: StoreState) =>
  state.fbOauthTokens.loaded;

export const fbOauthTokensShouldLoadSelector = (state: StoreState) =>
  !state.fbOauthTokens.loaded && !state.fbOauthTokens.busy;
